export default __webpack_public_path__ + "static/media/9.1.08ba003b.jpg";